import React from 'react';
import { NumericFormat } from 'react-number-format';
import TextField from '@material-ui/core/TextField';
import { decimalSeparator } from '../../utils';

export default function NumericTextField(props) {
    return (
        <NumericFormat
            customInput={TextField}
            label={props.label}
            name={props.name}
            id={props.id}
            placeholder={props.placeholder}
            decimalScale={4}
            decimalSeparator={`${decimalSeparator()}`}
            allowedDecimalSeparators={[',', '.']}
            fixedDecimalScale
            value={props.value}
            disabled={props.disabled}
            onChange={props.handleChange}
            onBlur={props.handleBlur}
            onFocus={props.onFocus}
            className={props.className}
        />
    );
}